/**
 * SlideNav.js
 */

import $ from 'jquery';
import { gsap, Expo } from 'gsap';

export default class SlideNav {

    constructor(element) {
        this.element = element;
        this.links = $(element).find('.nav-link');
        this.bubble = $(element).find('.nav-bubble');
        this.inner = $(element).find('.slide-nav-inner', this.element).get(0);

        this.setup();

        if(!element.classList.contains('primary-nav')){
          this.links.each( (_, link) => {
              link.addEventListener('click', this.clickLink.bind(this));
          })
        }
    }

    setup() {
        let { start } = this.inner.dataset;
        const duration = this.bubble.width() > 0 ? .5 : 0;

        if ( start === 'home' ) {
            gsap.to(this.bubble, {width: 0, duration, x: 0});
            return;
        }
        start = parseInt(start, 10);
        gsap.killTweensOf(this.bubble)
        if(this.bubble.hasClass('nav-bubble-drawer')){
            gsap.to(this.bubble, {width: this.links[$('.active_item').index()].offsetWidth, duration, x: this.links[$('.active_item').index()].offsetLeft});
        }else{
            gsap.to(this.bubble, {width: this.links[start].offsetWidth, duration, x: this.links[start].offsetLeft});
        }
    }

    clickLink(evt) {
        const target = evt.target
        gsap.killTweensOf(this.bubble)
        gsap.to(this.bubble, {width: target.offsetWidth, x: target.offsetLeft, duration: .5, ease: Expo.easeOut});
    }

}
